export const environment = {
  production: false,
  serverUrl: 'https://lsz-api-dev.azurewebsites.net/api/v1',
  auth0Config: {
    clientID: 'mYQ15bZwcNrrHzf5NS3Fd40VYBK5rjVv',
    domain: 'login.dev.sportec-solutions.de',
    responseType: 'token id_token',
    audience: 'https://apidev.lz-vergleichsdatenbank.de',
    redirectUri: 'https://lsz-web-frontend-dev.azurewebsites.net/callback',
    returnTo: 'https://lsz-web-frontend-dev.azurewebsites.net',
    scope: 'openid profile email',
  },
};
